module.exports = __webpack_public_path__ + "img/rule-6.101ac489.png";